module.exports = __webpack_public_path__ + "img/renshou.79c748d4.png";